import React from 'react'
import {SubHeader, ContactForm, Badge} from '../'

import './contactUs.css'

const ContactUs = () => {
    
  return (
    <>
      <div id='contact-us' className='contact-us-wrapper'>
        <Badge title="Contact" />
        <SubHeader title="Reach out to us" description="Call Today: +1-682-230-1236" />

        <div className='contact-us-container'>
          <div className='contact-us-form-cover'>
            <ContactForm />
          </div>
        </div>
      </div>
    </>
  )
}

export default ContactUs